import barba from '@barba/core';
import barbaCss from '@barba/css';

barba.use(barbaCss);

function resetScroll(transistion) {
	const breakpoint = 800;
	const currentContainer = transistion.next.container.parentNode.parentNode;

	if (window.innerWidth <= breakpoint) window.scroll(0, window.innerHeight * 0.5);
	if (window.innerWidth > breakpoint)
		currentContainer.scrollTo({
			top: 0,
			left: 0
		});
}

barba.init({
	views: [
		{
			namespace: 'home',
		},
		{
			namespace: 'sellers',
			beforeEnter(current) {
				resetScroll(current);
			}
		},
		{
			namespace: 'menu',
			beforeEnter(current) {
				resetScroll(current);
			}
		},
		{
			namespace: 'about',
			beforeEnter(current) {
				resetScroll(current);
			}
		}
	]
});
